import request from '../../../shared/request'

export function getTesting(job_id) {
  return request(`/job/testing/${job_id}/`)
}

export function createTesting(payload) {
  return request(`/job/testing/${payload.jobId}/`, {
    method: 'POST',
    body: payload.formData,
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

export function updateTesting(payload) {
  return request(`/job/testing/${payload.testingId}/`, {
    method: 'PUT',
    body: payload.formData,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteTesting(testingId) {
  return request(`/job/testing/${testingId}/`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

// ATTACHMENTS
export function uploadTestingAttachments(payload) {
  return request(`/job/testing/${payload.testingId}/attachment`, {
    method: 'POST',
    body: payload.formData,
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

export function fetchTestingAttachments(testingId) {
  return request(`/job/testing/${testingId}/attachments/`)
}

export function updateAttachmentDescription(payload) {
  return request(`/job/testing/${payload.attachmentId}/attachment`, {
    method: 'PUT',
    body: { description: payload.description },
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteTestingAttachment(payload) {
  return request(`/job/testing/${payload.attachmentId}/attachment/`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}



// WEBPACK FOOTER //
// ./src/redux/api/job/testing.js